import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-benchmark-stars',
    templateUrl: './benchmark-stars.component.html',
    styleUrls: ['./benchmark-stars.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BenchmarkStarsComponent {
  @Input('max') max = 5;
  @Input('title') title = 'benchmark';

  @Input('efficiency') efficiency = 0;
  @Input('score') score = 0;

  public scores: number[];

  constructor() {
    this.scores = new Array(this.max);
  }
}
